import React, { useEffect, useState } from 'react'
import { fetchListItems } from '../../../../../hooks/useCrud';
interface UiValeur {
    id?: number;
    titre?: string;
    description?: string;
    icone?: string;
    createdAt?: string;
    updatedAt?: string;
}
export default function Soutient() {
    const [listData, setDataList] = useState<UiValeur[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const fetchListData = async () => {
        setLoading(true);
        try {
            const res = await fetchListItems<UiValeur>('/fetch_choix_data');
            setDataList(res.data);

        } finally {
            setLoading(false);
        }

    }

    useEffect(() => {
        fetchListData();
    }, []);

    return (
        <div className="section panel overflow-hidden">
            <div className="section-outer panel py-4 md:py-6 lg:py-8 xl:py-9 bg-white dark:bg-gray-900">
                <div className="container max-w-2xl p-0 sm:px-2 lg:px-4 xl:px-0">
                    <div className="section-inner">
                        <div className="block-layout grid-layout vstack gap-3 sm:gap-4 xl:gap-5 panel">
                            <div className="block-header px-2 lg:px-0 text-center">
                                <h2 className="h4 md:h3 m-0">
                                    <i className="fas fa-star text-primary"></i>
                                    <span>Pourquoi Nous Choisir ?</span>
                                </h2>
                                <p className="fs-6 mt-2 text-gray-600 dark:text-gray-400">Découvrez les raisons qui font d'Ouragan Academy le choix idéal pour la formation basketball</p>
                            </div>
                            <div className="block-content container max-w-3xl">
                                <div className="row child-cols-12 sm:child-cols-2 lg:child-cols-4 g-4">

                                    {
                                        listData.length > 0 ? (
                                            listData.map(item => (
                                                <div className="text-center" key={item.id}>
                                                    <div className="panel p-4 bg-gray-25 dark:bg-gray-800 rounded-lg vstack gap-3 h-100">
                                                        <div className="w-80px h-80px bg-primary bg-opacity-10 rounded-circle hstack justify-center items-center mx-auto">
                                                            <i className={`${item.icone} text-primary text-2xl`}></i>
                                                        </div>
                                                        <h3 className="h5 m-0">{item.titre}</h3>
                                                        <p className="fs-7 m-0 text-gray-600">{item.description}</p>
                                                    </div>
                                                </div>
                                            ))
                                        ) : (
                                            <p>Aucun choix disponible</p>
                                        )
                                    }




                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
